import React from "react";
import { FunctionComponent } from "react";
import "./StickyProfilePicture.css";
import { profileUrl } from "../../information/information";
const observer = new IntersectionObserver(
  ([e]) => {
    const el = e.target.querySelector(".profilePictureContainer");
    //if el not found
    if (!el) return;
    if (e.intersectionRatio < 1) {
      el.classList.add("is-pinned");
    } else {
      el.classList.remove("is-pinned");
    }
  },
  { threshold: [1] }
);

interface StickyPictureProps {}

const StickyProfilePicture: FunctionComponent<StickyPictureProps> = () => {
  React.useEffect(() => {
    const el = document.querySelector("#StickyProfilePicture");
    if (el) observer.observe(el);
  }, []);
  return (
    <div id="StickyProfilePicture">
      <div className="profilePictureContainer">
        <img referrerPolicy="no-referrer" src={profileUrl} alt="profile" className="profilePicture"></img>
      </div>
    </div>
  );
};

export default StickyProfilePicture;
